import { useJsApiLoader } from '@react-google-maps/api';
import React from 'react';
const mapsLibraries = ['places', 'geometry'];
const GoogleMapScript = (props) => {
    if (!props.googledisabled) {
        const { isLoaded } = useJsApiLoader(Object.assign({ googleMapsApiKey: window.MAPS_KEY, libraries: mapsLibraries, region: window.country, language: window.language, id: 'maps-api' }, props));
        return isLoaded ? props.children : React.createElement(React.Fragment, null);
    }
    else {
        return props.children;
    }
};
export default GoogleMapScript;
